import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { StoreProvider } from './state/store'
import { registerServiceWorker } from './lib/pwa'
import { ErrorBoundary } from './components/ErrorBoundary'
import './styles/global.css'

registerServiceWorker()

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root')

createRoot(root).render(
  <StrictMode>
    {/* Outside StoreProvider on purpose: the readiness rail reads island data
        too, so a malformed record can take the shell down as easily as a view,
        and a boundary inside the tree it is guarding would go with it. */}
    <ErrorBoundary
      onReset={() => {
        localStorage.removeItem('language-island:v1')
        window.location.reload()
      }}
    >
      <StoreProvider>
        <App />
      </StoreProvider>
    </ErrorBoundary>
  </StrictMode>,
)
